import React, { JSX, ReactElement, ReactNode, useRef } from "react";
import { Box, Theme, useMediaQuery } from "@mui/material";
import { LayoutWithSidebarHeader } from "@components/common";
import { LoadingProgressBar } from "../../progress/LoadingProgressBar";

type Props = {
  breadcrumbs?: BreadcrumbItem[];
  children?: ReactNode;
  isFetching?: boolean;
  progressBar?: ReactElement;
  sidebar: JSX.Element;
  actionButton?: ReactElement;
  mobileHeader?: ReactElement;
  maxWidth?: number;
};

export const LayoutWithSidebar = ({
  breadcrumbs,
  children,
  isFetching,
  progressBar,
  sidebar,
  actionButton,
  mobileHeader,
  maxWidth = 736,
}: Props) => {
  const isMoreMd = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));
  const ref = useRef<HTMLDivElement>(null);

  return (
    <Box height={isMoreMd ? "100vh" : "auto"}>
      {isFetching ? <LoadingProgressBar position="relative" /> : progressBar}
      <Box display="flex" height="calc(100% - 5px)">
        {isMoreMd && sidebar}
        <Box width="100%" sx={{ overflowY: "auto" }} ref={ref}>
          <LayoutWithSidebarHeader
            sidebar={sidebar}
            breadcrumbs={breadcrumbs}
            actionButton={actionButton}
            mobileHeader={mobileHeader}
            maxWidth={maxWidth}
          />
          <Box>{children}</Box>
        </Box>
      </Box>
    </Box>
  );
};
